import React, {useState, useEffect, useRef} from 'react'
import apiClient from '../api/apiClient.js'
import {useAuth} from '../context/AuthContext'
import './StaffPage.css'
import './StudentClassStudentAdminPage.css'
import './UploadExams.css'
import './UploadExamsTeacher.css'

export default function UploadExamsTeacher(){
    const {user} = useAuth()
    const user_id = user.id;
    const sprogcenter_id = user.scId;

    const [censorId, setCensorId] = useState(null)
    const [examinatorTestGroupList, setExaminatorTestGroupList] = useState([])
    const [censorTestGroupList, setCensorTestGroupList] = useState([])

    const [currentTestGroup, setCurrentTestGroup] = useState(null)
    const [droppedFiles, setDroppedFiles] = useState([])
    const [isDragOver, setIsDragOver] = useState(false)
    const [files, setFiles] = useState([])
    const fileInputRef = useRef(null)

    async function getCensorId(){
        try{
            const result = await apiClient.get('/api/teacher/getcensorid', {
                params: {userId: user_id, sprogcenterId: sprogcenter_id}
            })
            const {censor_id} = result.data    
            console.log (`censor id fundet til ${censor_id} for ${user_id}`)
            setCensorId(censor_id)
        }catch(e){
            console.log("fejl ved FE hentning af censorid")
            console.log(e)
        }
    }    

    async function getName(censor_id){
        if(!censor_id) return 'Navn uafklaret'
        try {
            const result = await apiClient.get('/api/testgroup/getcensorname', {
                params: {censor_id}
            })
            const d = result?.data
            if(!d || (!d.fornavn && !d.efternavn)) return 'Navn uafklaret'
            return `${d.fornavn || ''} ${d.efternavn || ''}`.trim()
        } catch(e) {
            console.log("fejl ved getName", e)
            return 'Navn uafklaret'
        }
    }

   async function fetchTestGroups(){
        console.log("starting fecth with " + censorId)
        let examinatorList = []
        let censorList = []

        try{
            const result = await apiClient.get('/api/testgroup/allteachersgroups', 
                { params : {teacherID: user_id, sprogcenterID: sprogcenter_id} }
            )           

            if(result?.data){
                examinatorList = await Promise.all(
                    result.data.map(async (pg) => {
                        const teacherName = await getName(pg.underviser_id)
                        const censorName = await getName(pg.censor_id)
                        return {
                            ...pg,
                            eksaminator_navn: teacherName,
                            censor_navn: censorName,
                        }
                    })
                )
                setExaminatorTestGroupList(examinatorList)
            }
        }catch(e){
            console.log("fejl ved alle pg til eksaminator")
            console.log(e)
        }

        try{
            const result = await apiClient.get('/api/testgroup/allassessorsgroups', 
                { params : {assessorID: user_id, sprogcenterID: sprogcenter_id} }
            )
            if(result?.data){
                censorList = await Promise.all(
                    result.data.map(async (pg) =>{
                        const teacherName = await getName(pg.underviser_id)
                        const censorName = await getName(pg.censor_id)
                        return{
                            ...pg, 
                            eksaminator_navn: teacherName, 
                            censor_navn: censorName,
                        }
                    })
                )
                setCensorTestGroupList(censorList)
            }
        }catch(e){
            console.log("fejl ved alle pg til censor")
            console.log(e)
        }

        const merged = []
        const seen = new Set()
        for (const tg of [...examinatorList, ...censorList]) {
            if (tg?.id != null && !seen.has(tg.id)) {
                seen.add(tg.id)
                merged.push(tg)
            }
        }
        return merged
    }

    useEffect( ()=>{
         getCensorId()
    }, [])

    useEffect( ()=>{
        if(censorId) fetchTestGroups()
    }, [censorId])

    function handleDragOver(e){
        e.preventDefault()
        setIsDragOver(true)
    }

    function handleDragLeave(e){
        e.preventDefault()
        setIsDragOver(false)
    }

    async function handleDrop(e){
        e.preventDefault()
        setIsDragOver(false)
        if(currentTestGroup === null)
            return

        const pdfFiles = Array.from(e.dataTransfer.files).filter(
            f => f.type === 'application/pdf'
        )
        setFiles(pdfFiles)
        if (pdfFiles.length === 0) return

        try{
            const formData = new FormData()
            formData.append('file', pdfFiles[0])
            formData.append('studentID', null)
            formData.append('testGroupID', currentTestGroup.id)
            await apiClient.post('/api/uploadfile', formData, {
                headers: {'Content-Type': 'multipart/form-data'},
                timeout: 120000
            })

            const fresh = await fetchTestGroups()
            if(currentTestGroup){
                setCurrentTestGroup(fresh.find(s=> s.id === currentTestGroup.id) || null)
            }

        }catch(e){
            console.log("fejl ved fil upload")
            console.log(e)
        }
        setDroppedFiles(prev => [...prev, ...pdfFiles])
    }

    function handleDropZoneClick() {
        if (currentTestGroup === null) return
        fileInputRef.current?.click()
    }

    async function handleFileInputChange(e) {
        const input = e.target
        if (currentTestGroup === null) {
            input.value = ''
            return
        }
        const picked = Array.from(input.files || []).filter(
            (f) => f.type === 'application/pdf'
        )
        input.value = ''
        if (picked.length === 0) return

        setFiles(picked)
        try {
            const formData = new FormData()
            formData.append('file', picked[0])
            formData.append('studentID', null)
            formData.append('testGroupID', currentTestGroup.id)
            await apiClient.post('/api/uploadfile', formData, {
                headers: {'Content-Type': 'multipart/form-data'},
                timeout: 120000
            })
            const fresh = await fetchTestGroups()
            if (currentTestGroup) {
                setCurrentTestGroup(fresh.find((s) => s.id === currentTestGroup.id) || null)
            }
        } catch (err) {
            console.log('fejl ved fil upload', err)
        }
        setDroppedFiles((prev) => [...prev, ...picked])
    }

    useEffect(()=>{
        fetchTestGroups()
    }, [currentTestGroup])


    async function handleDownload(thisFilename){
        try{
            const result = await apiClient.get('/api/downloadfile', {
                params: {filename: thisFilename}, 
                responseType: 'blob'
            })
            const url = window.URL.createObjectURL(result.data)
            const a = document.createElement('a')
            a.href = url
            a.download = thisFilename
            a.click()
            window.URL.revokeObjectURL(url)
        }catch(e){
            console.log("fejl ved download af " + thisFilename)
            console.log(e)
        }
    }
    const no_go_sc_id = [2, 25, 42, 43, 53, 70, 74, 75, 83]
    return(
        <div className="panel-container upload-exams-page upload-teacher-page">
            <div className="panel">
                <div className="teacher-role-block">
                {examinatorTestGroupList.length === 0 ? (
                    <p className="upload-muted">Ikke nogen prøver uploadet i rollen som eksaminator</p>
                ):(
                    <div>
                        <span className="upload-section-title">
                            Uploaded prøver fra dit sprogcenter (eksaminator)
                        </span>
                        {examinatorTestGroupList.map(eTG => (
                            <div key={eTG.id} className="teacher-table-wrap">
                                <table className="censor-table">
                                    <thead>
                                        <tr>
                                            <th>Afsendende sprogcenter</th>
                                            <th>Prøvegruppe</th>
                                            <th>Eksaminator</th>
                                            <th>Censor</th>
                                        </tr>
                                    </thead>
                                    <tbody>                                    
                                        <tr
                                            className={`upload-row-selectable ${currentTestGroup?.id === eTG.id ? 'upload-row-selected' : ''}`}
                                            onClick={() => setCurrentTestGroup(eTG)}
                                        >
                                            <td>{eTG.sprogcenter_navn}</td>
                                            <td>{eTG.navn}</td>
                                            <td>{eTG.eksaminator_navn}</td>
                                            <td>{eTG.censor_navn}</td>
                                        </tr>                                    
                                    </tbody>
                                </table>
                            </div>
                        ))
                        }
                    </div>
                )}
                </div>
                <div className="teacher-role-block">
                {censorTestGroupList.length ===0 ? (
                    <p className="upload-muted">Ikke nogen prøver uploadet i rollen som censor</p>
                ):(
                    <div>
                        <span className="upload-section-title">
                            Uploaded prøver fra andre sprogcentre (censor)
                        </span>
                        {censorTestGroupList.map(cTG => (
                            <div key={cTG.id} className="teacher-table-wrap">
                                <table className="censor-table">
                                    <thead>
                                        <tr>
                                            <th>Prøvegruppe</th>
                                            <th>Afsendende sprogcenter</th>
                                            <th>Eksaminator</th>
                                            <th>Censor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            className={`upload-row-selectable ${currentTestGroup?.id === cTG.id ? 'upload-row-selected' : ''}`}
                                            onClick={() => setCurrentTestGroup(cTG)}
                                        >
                                            <td>{cTG.navn}</td>
                                            <td>{cTG.sprogcenter_navn}</td>
                                            <td>{cTG.eksaminator_navn}</td>
                                            <td>{cTG.censor_navn}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        ))
                        }
                    </div>
                )}
                </div>
            </div>
            <div className="panel">
                <span className="panel-text">
                    <b>Testgruppe: </b>{currentTestGroup?.navn ?? '—'}
                </span>
                <input
                    ref={fileInputRef}
                    type="file"
                    accept=".pdf,application/pdf"
                    style={{ display: 'none' }}
                    aria-hidden="true"
                    tabIndex={-1}
                    onChange={handleFileInputChange}
                />
                <div
                    role="button"
                    tabIndex={currentTestGroup ? 0 : -1}
                    aria-disabled={!currentTestGroup}
                    onClick={handleDropZoneClick}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault()
                            handleDropZoneClick()
                        }
                    }}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    className={`upload-drop-zone${isDragOver ? ' upload-drop-zone--active' : ''}${currentTestGroup ? '' : ' upload-drop-zone--inactive'}`}
                >   
                    <p>
                        Træk PDF-filer hertil, eller klik for at vælge fil
                    </p>
                </div>
                <span className="upload-section-title">
                    Besvarelser uploadet til testgruppen
                </span>
                {no_go_sc_id.includes(sprogcenter_id) ? (
                    <p>Kontakt dit sprogcenters administration for prøver</p>
                ) : !currentTestGroup?.examupload_filenames?.length ? (
                    <p className="upload-muted">Ingen filer uploadet</p>
                ):(
                    <table className="censor-table">
                        <thead>
                            <tr>
                                <th>Filnavn</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentTestGroup?.examupload_filenames?.map(file => (
                                <tr key={file}>
                                    <td>
                                        <div className="upload-file-name">{file}</div>
                                        <div className="upload-file-actions">
                                            <button
                                                type="button"
                                                className="tg-table-action"
                                                onClick={() => handleDownload(file)}
                                            >
                                                Download
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    )
}
